import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar 进度条
import 'nprogress/nprogress.css' // progress bar style 进度条风格
import { getToken } from '@/utils/auth' // get token from cookie 从cookie 中获得token
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist 不需要登录的白名单

router.beforeEach(async(to, from, next) => {
  // start progress bar 进度条开始
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      // 如果路径是 且已经登录 跳转到home
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      // 确定用户是否已通过getInfo获得其权限角色
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info 获取用户权限信息 roles必须是个数组
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          await store.dispatch('user/getInfo')
          // await store.dispatch('sys_config/loadConfig')

          // generate accessible routes map based on roles
          // 基于角色生成 可访问路由映射
          const accessRoutes = await store.dispatch('permission/generateRoutes')

          // dynamically add accessible routes
          // 动态添加可访问的路由
          router.addRoutes(accessRoutes)

          // 添加404路由
          router.addRoutes([{ path: '*', redirect: '/404', hidden: true }])

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record 这样导航就不会留下历史记录
          next({ ...to, replace: true })
        } catch (error) {
          // // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          console.info(error)
          next(`/login?redirect=${to.path}`)
          // location.href = 'http://shop.card.nmgjoin.com/Login?return_url=' + encodeURI(return_url_str)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // 在自由登录白名单中直接登录
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)

      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
